function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
const _require = require('../library'),
  get = _require.get,
  createInvariantWithPrefix = _require.createInvariantWithPrefix,
  memoize = _require.memoize;
const _require2 = require('../core'),
  createBreakpoints = _require2.createBreakpoints;
const defaultOptions = {
  errorPrefix: '[styled-breakpoints]: ',
  pathToMediaQueries: 'breakpoints',
  defaultBreakpoints: {
    xs: '0px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1400px'
  }
};
exports.createStyledBreakpoints = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  const invariant = createInvariantWithPrefix(options.errorPrefix);
  const checkAllValuesHasPixels = memoize(breakpoints => {
    const invalidBreakpoints = Object.entries(breakpoints).reduce((acc, _ref) => {
      let _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      const hasPx = /^\d+px$/;
      if (!hasPx.test(value)) {
        acc += `${key}: ${value}, `;
      }
      return acc;
    }, '');
    invariant(invalidBreakpoints.length === 0, `Check your theme. \`${invalidBreakpoints.trimEnd()}\` are invalid breakpoints. Use only pixels.`);
  });
  const getMediaQueriesFromTheme = _ref3 => {
    let _ref3$theme = _ref3.theme,
      theme = _ref3$theme === void 0 ? {} : _ref3$theme;
    const memoizedGet = memoize(get);
    const memoizedMediaQueries = memoizedGet(theme, options.pathToMediaQueries, options.defaultBreakpoints);
    checkAllValuesHasPixels(memoizedMediaQueries);
    return memoizedMediaQueries;
  };
  const withBreakpoints = fn => props => {
    const mediaQueriesFromTheme = getMediaQueriesFromTheme(props);
    const breakpoints = createBreakpoints({
      breakpoints: mediaQueriesFromTheme,
      errorPrefix: options.errorPrefix
    });
    return fn(breakpoints);
  };
  const checkIsValidOrientation = x => {
    const validOrientations = x === 'portrait' || x === 'landscape';
    invariant(validOrientations, `\`${x}\` is invalid orientation. Use \`landscape\` or \`portrait\`.`);
  };
  const withOrientation = (mediaQuery, orientation) => {
    checkIsValidOrientation(orientation);
    return `${mediaQuery} and (orientation: ${orientation})`;
  };
  const withOrientationOrNot = memoize((orientation, result) => orientation ? withOrientation(result, orientation) : result);
  const withMinAndMaxMedia = _ref4 => {
    let min = _ref4.min,
      max = _ref4.max;
    return `@media (min-width: ${min}) and (max-width: ${max})`;
  };
  return {
    up: (name, orientation) => withBreakpoints(_ref5 => {
      let up = _ref5.up;
      return withOrientationOrNot(orientation, `@media (min-width: ${up(name)})`);
    }),
    down: (name, orientation) => withBreakpoints(_ref6 => {
      let down = _ref6.down;
      return withOrientationOrNot(orientation, `@media (max-width: ${down(name)})`);
    }),
    between: (min, max, orientation) => withBreakpoints(_ref7 => {
      let between = _ref7.between;
      return withOrientationOrNot(orientation, withMinAndMaxMedia(between(min, max)));
    }),
    only: (name, orientation) => withBreakpoints(_ref8 => {
      let only = _ref8.only;
      return withOrientationOrNot(orientation, withMinAndMaxMedia(only(name)));
    })
  };
};